import request from '../utils/fetch';

/**
 * 场景数据实体
 */
export interface MPAppScene {
  /**
   * 场景中文名
   */
  label: string;
  /**
   * 场景Code
   */
  value: string;
}

// 获取企业空间列表&&查询企业
export async function getEnterpriseListApi(params: any): Promise<any> {
  return request(`/account/v1/boss/enterprise/list`, {
    tokenFree: false,
    method: 'GET',
    params: params,
  });
}

// 获取指定企业下的项目列表
export async function getProjectListApi(enterpriseId: string): Promise<any> {
  return request(`/project/v1/${enterpriseId}/projects?pageSize=999999`, {
    tokenFree: false,
    method: 'GET',
  });
}

// 获取指定项目信息
export async function getProjectApi(projectId: string): Promise<any> {
  return request(`/project/v1/projects/${projectId}/info`, {
    tokenFree: false,
    method: 'GET',
  });
}

// 获取指定企业信息
export async function getEnterpriseInfoApi(enterpriseId: string): Promise<any> {
  return request(`/account/v1/enterprises/${enterpriseId}/info`, {
    tokenFree: false,
    method: 'GET',
  });
}

/**
 * 获取小程序所属场景枚举列表
 * @param params {
 *   type: 小程序类型（独立、项目小程序）
 *   page: 当前页码
 *   pageSize: 每页条数
 * }
 */
export async function listScenes(): Promise<any> {
  const res: any = await request(`/account/v1/mpApp/scenes`, {
    tokenFree: false,
    method: 'GET',
  });
  if (res.success) {
    let scenesList: Array<MPAppScene> = [];
    Object.keys(res?.data).forEach((key) => {
      scenesList.push({
        label: res.data[key],
        value: key,
      });
    });
    // 排个序
    scenesList = scenesList.sort((item1: any, item2: any) => {
      return item1.label.localeCompare(item2.label);
    });
    return scenesList;
  }
}

/**
 * 保存小程序应用信息
 * @param params {
 *   id: Id
 *   type: 小程序类型（独立、项目小程序）
 *   sceneCode: 场景值（天宫云、元车位、精装）
 *   projectId: 项目ID（项目小程序时有）
 *   appId: 小程序应用ID
 *   appSecret: 小程序密钥
 *   enableWxGetUnlimitedQrcodeApi: 是否开启获取微信无限小程序码调用API
 * }
 */
export async function submitAppApi(params: {
  id: string;
  type: number;
  sceneCode: string;
  projectId: string;
  appId: string;
  appSecret: string;
  enableWxGetUnlimitedQrcodeApi: boolean;
  validationFile: string;
  privateKeyFile: string;
  enableWxLogin: boolean;
}): Promise<any> {
  return request(`/account/v1/mpApp`, {
    tokenFree: false,
    method: 'POST',
    data: params,
  });
}

/**
 * 删除小程序应用信息
 * @param id 应用ID
 */
export async function deleteAppApi(id: string): Promise<any> {
  return request(`/account/v1/mpApp/${id}`, {
    tokenFree: false,
    method: 'DELETE',
  });
}

/**
 * 获取小程序应用信息
 * @param id 应用ID
 */
export async function getAppInfoByAppIdApi(appId: string): Promise<any> {
  return request(`/account/v1/mpApp/info/byAppId?appId=${appId}`, {
    tokenFree: false,
    method: 'GET',
  });
}

/**
 * 检索小程序应用信息
 * @params {
 *   type: 小程序类型（独立、项目小程序）
 *   page: 当前页码
 *   pageSize: 每页条数
 * }
 */
export async function queryAppApi(params: {
  type: number;
  page: number;
  pageSize: number;
  query: string;
}): Promise<any> {
  return request(
    `/account/v1/mpApp/search?type=${params.type}&page=${params.page}&pageSize=${params.pageSize}&query=${params.query}`,
    {
      tokenFree: false,
      method: 'GET',
    },
  );
}

/**
 * 查询购买资源包的用量情况（手机快速验证）
 * @params {
 *   appId: 小程序应用ID
 * }
 */
export async function getAppChargeUsageApi(params: { appId: string }): Promise<any> {
  return request(`/boss/api/wechat/app/${params.appId}/charge/phone-verify/usage`, {
    tokenFree: false,
    method: 'GET',
  });
}

/**
 * 获取某个付费能力的最近用量数据（手机快速验证）
 * @params {
 *   appId: 小程序应用ID
 * }
 */
export async function getAppChargeRecentAverageUsageApi(params: { appId: string }): Promise<any> {
  return request(
    `/boss/api/wechat/app/${params.appId}/charge/phone-verify/recent/average-usage?spuId=`,
    {
      tokenFree: false,
      method: 'GET',
    },
  );
}
